import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import PDPProtectionPlanSelector from 'components/consumer/PDP/PDPProtectionPlanSelector';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import BrowserOnly from 'components/consumer/BrowserOnly';
import useIsBrowser from 'hooks/useIsBrowser';
import PDPDesktopPhotoPanel from '../PDPDesktopPhotoPanel';
import PDPNameSection from '../PDPNameSection';
import PDPShopTabsBar from '../PDPShopTabsBar';
import PDPAvailableInSizes from '../PDPAvailableInSizes';
import PDPOnDisplayInShowroom from '../PDPOnDisplayInShowroom';
import PDPAddToBagSection from '../PDPAddToBagSection';
import PDPCompleteOrder from '../PDPCompleteOrder';
import PDPUpSellProduct from '../PDPUpSellProduct';
import PDPSellingAttributes from '../PDPSellingAttributes';
import PDPProductDescription from '../PDPProductDescription';
import PDPDimensionsAndDetails from '../PDPDimensionsAndDetails';
import BVReviewsOnShowHost from '../BazaarVoice/BVReviewsOnShowHost';
import PDPCustomerPhotos from '../PDPCustomerPhotos';
import PDPBreadCrumbs from '../PDPBreadCrumbs';
import PDPAlertBar from '../PDPAlertBar';
import PDPAlertsSection from '../PDPAlertsSection';
import PDPDiscontinuedMessage from '../PDPDiscontinuedMessage';
import PDPChooseYourOptions from '../PDPChooseYourOptions';
const PDPCollectionSlider = loadable(() => import('../PDPCollectionSlider'));
const ModularAddProductsMarxent = loadable(() => import('components/consumer/modular-configurator/ModularAddProducts/marxent'));

/**
 * Desktop layout: photo panel is a sibling of the stock-gated configurator rail
 * (not nested under it). Outer full-page Suspense was removed — hero/context
 * boundaries live in PDPHeroShell / PDPContextRegion; sections keep their own.
 */
const PDPDesktop = t0 => {
  const $ = _c(59);
  const {
    discontinuedCategoryMsg: t1,
    pdpIsModularBYOProduct: t2,
    isEditOrder,
    isOutOfStock: t3,
    showDiscontinuedNotification: t4,
    showOutOfStockNotification: t5,
    slug,
    productHeroImage: t6,
    productCylindoHeroImage: t7
  } = t0;
  const discontinuedCategoryMsg = t1 === undefined ? null : t1;
  const pdpIsModularBYOProduct = t2 === undefined ? false : t2;
  const isOutOfStock = t3 === undefined ? false : t3;
  const showDiscontinuedNotification = t4 === undefined ? false : t4;
  let t8;
  if ($[0] !== t5) {
    t8 = t5 === undefined ? {} : t5;
    $[0] = t5;
    $[1] = t8;
  } else {
    t8 = $[1];
  }
  const showOutOfStockNotification = t8;
  const productHeroImage = t6 === undefined ? null : t6;
  const productCylindoHeroImage = t7 === undefined ? null : t7;
  const isBrowser = useIsBrowser();
  const [displayPressComp, setDisplayPressComp] = useState(false);
  const [marxentSelectedFabric, setMarxentSelectedFabric] = useState(null);
  const [hideMarxent, setHideMarxent] = useState(true);
  const [unavailableFabric, setUnavailableFabric] = useState(false);
  let t9;
  if ($[2] !== isEditOrder) {
    t9 = <PDPNameSection isEditOrder={isEditOrder} />;
    $[2] = isEditOrder;
    $[3] = t9;
  } else {
    t9 = $[3];
  }
  let t10;
  if ($[4] !== isBrowser || $[5] !== isEditOrder) {
    t10 = !isEditOrder && isBrowser ? <PDPAvailableInSizes /> : <div className="PDPDesktop__PDPAvailableInSizes-filler" />;
    $[4] = isBrowser;
    $[5] = isEditOrder;
    $[6] = t10;
  } else {
    t10 = $[6];
  }
  let t11;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <PDPOnDisplayInShowroom />;
    $[7] = t11;
  } else {
    t11 = $[7];
  }
  let t12;
  if ($[8] !== discontinuedCategoryMsg || $[9] !== showDiscontinuedNotification) {
    t12 = showDiscontinuedNotification ? <PDPAlertBar type="error"><PDPDiscontinuedMessage discontinuedCategoryMsg={discontinuedCategoryMsg} /></PDPAlertBar> : <div className="PDPDesktop__PDPAlertBar-filler" />;
    $[8] = discontinuedCategoryMsg;
    $[9] = showDiscontinuedNotification;
    $[10] = t12;
  } else {
    t12 = $[10];
  }
  let t13;
  if ($[11] !== isEditOrder || $[12] !== isOutOfStock || $[13] !== marxentSelectedFabric || $[14] !== pdpIsModularBYOProduct || $[15] !== showDiscontinuedNotification || $[16] !== slug || $[17] !== unavailableFabric) {
    t13 = !isOutOfStock && !showDiscontinuedNotification ? <div className="PDPDesktop__in-stock-options">{pdpIsModularBYOProduct && <BrowserOnly><div className="border-t border-gray-light7"><SuspenseWithLoader><ModularAddProductsMarxent marxentSelectedFabric={marxentSelectedFabric} unavailableFabric={unavailableFabric} setHideMarxent={setHideMarxent} setUnavailableFabric={setUnavailableFabric} key={slug} /></SuspenseWithLoader></div></BrowserOnly>}<PDPShopTabsBar isEditOrder={isEditOrder} /><PDPChooseYourOptions isEditOrder={isEditOrder} setMarxentSelectedFabric={setMarxentSelectedFabric} />{!isEditOrder && <PDPUpSellProduct />}{!isEditOrder && !pdpIsModularBYOProduct && <PDPProtectionPlanSelector />}</div> : <div className="PDPDesktop__in-stock-options-filler" />;
    $[11] = isEditOrder;
    $[12] = isOutOfStock;
    $[13] = marxentSelectedFabric;
    $[14] = pdpIsModularBYOProduct;
    $[15] = showDiscontinuedNotification;
    $[16] = slug;
    $[17] = unavailableFabric;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== isOutOfStock || $[20] !== showDiscontinuedNotification || $[21] !== showOutOfStockNotification) {
    t14 = isOutOfStock && !showDiscontinuedNotification ? <PDPAlertsSection showOutOfStockNotification={showOutOfStockNotification} /> : <div className="PDPDesktop__PDPAlertSection-filler" />;
    $[19] = isOutOfStock;
    $[20] = showDiscontinuedNotification;
    $[21] = showOutOfStockNotification;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== isEditOrder || $[24] !== isOutOfStock) {
    t15 = isEditOrder ? <PDPCompleteOrder /> : <PDPAddToBagSection isOutOfStock={isOutOfStock} isEditOrder={isEditOrder} />;
    $[23] = isEditOrder;
    $[24] = isOutOfStock;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <PDPSellingAttributes />;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== isEditOrder) {
    t17 = !isEditOrder ? <PDPProductDescription /> : <div className="PDPDesktop__PDPProductDescription-filler" />;
    $[27] = isEditOrder;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== pdpIsModularBYOProduct) {
    t18 = !pdpIsModularBYOProduct ? <PDPDimensionsAndDetails /> : <div className="PDPDesktop__PDPDimensionsAndDetails-filler" />;
    $[29] = pdpIsModularBYOProduct;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== isEditOrder || $[32] !== slug) {
    t19 = !isEditOrder ? <PDPCustomerPhotos slug={slug} /> : <BVReviewsOnShowHost />;
    $[31] = isEditOrder;
    $[32] = slug;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== displayPressComp) {
    t20 = !displayPressComp ? <SuspenseWithLoader><PDPCollectionSlider setDisplayPressComp={setDisplayPressComp} /></SuspenseWithLoader> : <div className="PDPDesktop__PDPPress-filler" />;
    $[34] = displayPressComp;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== t10 || $[37] !== t12 || $[38] !== t13 || $[39] !== t14 || $[40] !== t15 || $[41] !== t17 || $[42] !== t18 || $[43] !== t19 || $[44] !== t20 || $[45] !== t9) {
    t21 = <div className="flex-none min-w-[460px] w-[460px] [@media(width:1024px)]:min-w-[400px] [@media(width:1024px)]:w-[400px]">{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}{t18}{t19}{t20}</div>;
    $[36] = t10;
    $[37] = t12;
    $[38] = t13;
    $[39] = t14;
    $[40] = t15;
    $[41] = t17;
    $[42] = t18;
    $[43] = t19;
    $[44] = t20;
    $[45] = t9;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <PDPBreadCrumbs />;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== hideMarxent || $[49] !== isEditOrder || $[50] !== pdpIsModularBYOProduct || $[51] !== productCylindoHeroImage || $[52] !== productHeroImage || $[53] !== slug || $[54] !== unavailableFabric) {
    t23 = <div className="flex-1 mr-12">{t22}<PDPDesktopPhotoPanel slug={slug} isEditOrder={isEditOrder} pdpIsModularBYOProduct={pdpIsModularBYOProduct} hideMarxent={hideMarxent} unavailableFabric={unavailableFabric} productHeroImage={productHeroImage} productCylindoHeroImage={productCylindoHeroImage} /></div>;
    $[48] = hideMarxent;
    $[49] = isEditOrder;
    $[50] = pdpIsModularBYOProduct;
    $[51] = productCylindoHeroImage;
    $[52] = productHeroImage;
    $[53] = slug;
    $[54] = unavailableFabric;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  let t24;
  if ($[56] !== t21 || $[57] !== t23) {
    t24 = <FixedWidthContainer wide={true} className="flex flex-row-reverse !pt-2 !pb-8 max-[1023px]:hidden" data-xc="PDPDesktop">{t21}{t23}</FixedWidthContainer>;
    $[56] = t21;
    $[57] = t23;
    $[58] = t24;
  } else {
    t24 = $[58];
  }
  return t24;
};
PDPDesktop.propTypes = {
  discontinuedCategoryMsg: PropTypes.shape({
    category: PropTypes.string,
    link: PropTypes.string
  }),
  isEditOrder: PropTypes.bool,
  isOutOfStock: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  showDiscontinuedNotification: PropTypes.bool,
  showOutOfStockNotification: PropTypes.shape({
    productId: PropTypes.number,
    show: PropTypes.bool
  }),
  slug: PropTypes.string,
  productHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  }),
  productCylindoHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  })
};
export default PDPDesktop;